export enum ERROR_CODE {
  FORBIDDEN = '403',
  SERVER_ERROR = '5xx',
  CHALLENGE = 'CHL',
}

export const ErrorCodeRecordDescription: Record<ERROR_CODE, string> = {
  [ERROR_CODE.SERVER_ERROR]: 'ErrorHandler.originLabel',
  [ERROR_CODE.FORBIDDEN]: 'ErrorHandler.blockLabel',
  [ERROR_CODE.CHALLENGE]: 'ErrorHandler.challenge',
};

export const ErrorCodeRecord: Record<ERROR_CODE, string> = {
  [ERROR_CODE.SERVER_ERROR]: '5xx',
  [ERROR_CODE.FORBIDDEN]: '403',
  [ERROR_CODE.CHALLENGE]: 'CHL',
};

export const ErrorCodeRecordLabel: Record<ERROR_CODE, string> = {
  [ERROR_CODE.SERVER_ERROR]: '(502, 503, 504)',
  [ERROR_CODE.FORBIDDEN]: '(403)',
  [ERROR_CODE.CHALLENGE]: '',
};
